import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const BusinessAnalysisServices: React.FC<Props> = ({ title }) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
              We do a thorough analysis of your business ideas and work to bring them to fruition. We also evaluate the risks and show bottlenecks in your projects thus helping you avoid failed decisions, and saving time and money.
              </p>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Reduce out-of-scope rework and boost the development cycle." />
              <KEYBlue text="Fill out the gaps in overall understanding and lay out the project roadmap." />
              <KEYBlue text="Mitigate the risk of inaccurate requirements." />
              <KEYBlue text="Help the stakeholders to define the specific, measurable, and achievable objectives." />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Boost the product-to-market time." />
              <KEYBlue text="Reduced abandonment rate and onboarding cost." />
              <KEYBlue text="Save a significant amount of overall development cost and time efforts." />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BusinessAnalysisServices
